import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { previewModalCurrentIndexSet, previewModalExpansionToggle } from 'Global/Stores/previewModal'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    expanded: selectors.expanded(state),
    index: selectors.index(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    setCurrentIndex: index => dispatch(previewModalCurrentIndexSet(index)),
    toggleExpansion: index => dispatch(previewModalExpansionToggle()),
  })

  Enhancer.displayName = 'PreviewModalEnhancer'

  Enhancer.propTypes = {
    disableRugInformation: PropTypes.bool,
    expanded: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    rugs: PropTypes.array.isRequired,
    setCurrentIndex: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    toggleExpansion: PropTypes.func.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
